






































import { Component, Prop, Vue } from 'vue-property-decorator'
import { SelectionType, TileType } from '@/data/enums'
import AgeSlider from './ui/AgeSlider.vue'
import ProfileStep from './ProfileStep.vue'

@Component({
  components: {
    AgeSlider,
    ProfileStep
  },
  computed: {
    ageValue: {
      get () {
        return this.$store.state.matrix.age
      },
      set (value) {
        this.$store.dispatch('matrix/setAge', parseInt(value, 0))
          .catch((err) => console.error(err))
      }
    }
  }
})
export default class CustomerIdentity extends Vue {
  @Prop({ default: 16 }) public min!: number
  @Prop({ default: 60 }) public max!: number
  @Prop({ default: -1 }) public currentStep?: number
  @Prop() public tileType!: TileType
  @Prop() public type!: SelectionType
  @Prop() public prev!: string
  @Prop() public next!: string
  @Prop() public extra!: string
}
